'use strict';

var migrateReportDinamicEmail = require('../dashboard-builder/formConfig/migrateReportDinamicEmail');
var reviewImport = require('./importFormReview');
var sanitizeMongoKeys = require('../utils/sanitizeMongoKeys');

module.exports = function($scope, $state, Department, departments, dialog, forms, departmentReportConfig, Integration, $translate, Authentication, $uibModal, toast) {
    $scope.fileContent = "";
    var _this = this;
    this.department = departments.filter(function(department) {
        return department.id === $state.params.departmentId;
    })[0];
    this.currentUserIsViewer = Authentication.isOnlyViewerInDept();  //Authentication.isAuthorized("viewer");
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");

    this.baseUrl = require('../server').server;
    this.department.forms = forms;
    this.showArchived = false;

    this.archivedFilter = function(form) {
        if (_this.showArchived) {
            return true;
        }
        return !form.archived;
    };

    this.departmentReportConfig = departmentReportConfig;
    if (Array.isArray(departmentReportConfig) && departmentReportConfig.length > 0) {
        this.department.reportConfig = departmentReportConfig[0];
    } else if (!Array.isArray(departmentReportConfig)) {
        this.department.reportConfig = departmentReportConfig;
    }

    this.createForm = function() {
        dialog.confirm({
            title: $translate.instant('DASHBOARD.DASH_FORM.DIAG_CREATE.TITLE'),
            body: $translate.instant('DASHBOARD.DASH_FORM.DIAG_CREATE.BODY'),
            accept: $translate.instant('DASHBOARD.ACCEPT'),
            cancel: $translate.instant('DASHBOARD.CANCEL'),
            size: 'sm'
        }).then(function() {
            $state.go('dashboard.departments.department.forms.form.builder', {
                formId: 'new'
            });
        });
    };

    this.importForm = function () {
        toast.loading($translate.instant("DASHBOARD.LOADING"));
        $uibModal
        .open({
            animation: true,
            templateUrl: "dashboard-forms/importFormDialog.html",
            controller: [
                "$scope",
                "$uibModalInstance",
                "Department",
                "ReportConfig",
                function (
                    $scope,
                    $uibModalInstance,
                    Department,
                    ReportConfig,
                ) {
                    var _this = this;
                    $scope.fileContent = undefined;
                    _this.fileContent = undefined;
                    _this.formName = "";
                    _this.importNotes = [];
                    _this.integrationChoices = [];
                    _this.tenantIntegrations = [];
                    _this.integrationOptions = [];
                    _this.integrationsReady = false;
                    _this.CREATE_NEW = "__create__";
                    _this.createdIntegrationNames = [];
                    _this.reusedIntegrationNames = [];

                    _this.refreshIntegrationOptions = function () {
                        const sorted = _this.tenantIntegrations.slice().sort(function (a, b) {
                            return (a.name || "").localeCompare(b.name || "");
                        });
                        _this.integrationOptions = [{
                            id: _this.CREATE_NEW,
                            name: $translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.INTEGRATION_CREATE"),
                        }].concat(sorted);
                    };

                    _this.buildIntegrationChoices = function () {
                        const fileIntegrations = (_this.fileContent && _this.fileContent.integrations) || [];
                        const byId = {};
                        _this.tenantIntegrations.forEach(function (integration) {
                            byId[integration.id] = integration;
                        });

                        _this.integrationChoices = fileIntegrations.map(function (integration) {
                            const existingById = byId[integration.id];
                            if (existingById) {
                                return {
                                    oldId: integration.id,
                                    name: integration.name,
                                    matchedById: true,
                                    selectedId: existingById.id,
                                };
                            }

                            const targetName = (integration.name || "").trim().toLowerCase();
                            const existingByName = _this.tenantIntegrations.find(function (item) {
                                return (item.name || "").trim().toLowerCase() === targetName;
                            });

                            return {
                                oldId: integration.id,
                                name: integration.name,
                                matchedById: false,
                                selectedId: existingByName ? existingByName.id : _this.CREATE_NEW,
                            };
                        });
                    };

                    _this.setImportNotes = function (fileContent) {
                        let createIds = null;
                        if (_this.integrationChoices.length) {
                            createIds = {};
                            _this.integrationChoices.forEach(function (choice) {
                                if (choice.selectedId === _this.CREATE_NEW) {
                                    createIds[choice.oldId] = true;
                                }
                            });
                        }
                        _this.importNotes = reviewImport(fileContent, createIds).map(function (note) {
                            return $translate.instant(
                                "DASHBOARD.DASH_FORM.DIAG_IMPORT.REVIEW." + note.id,
                                note.params || {}
                            );
                        });
                    };

                    Integration.find().$promise.then(function (integrationsList) {
                        _this.tenantIntegrations = integrationsList || [];
                        _this.integrationsReady = true;
                        _this.refreshIntegrationOptions();
                        if (_this.fileContent) {
                            _this.buildIntegrationChoices();
                            _this.setImportNotes(_this.fileContent);
                        }
                    });
                    
                    _this.clearFileInput = function (error) {
                        // First time loading file
                        if ($scope.fileContent === undefined) {
                            _this.openNewFile();
                        // Else, file data will be delete
                        } else {
                            if (error) {
                                $scope.fileContent = undefined;
                                _this.fileContent = undefined;
                                _this.formName = "";
                                _this.importNotes = [];
                                _this.integrationChoices = [];

                                dialog.confirm({
                                    title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.SELECT_FILE"),
                                    body: $translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.FILE_WITHOUT_FORM"),
                                    accept: $translate.instant("DASHBOARD.ACCEPT"),
                                    cancel: $translate.instant("DASHBOARD.CANCEL"),
                                    size: "md",
                                })
                                .then(function () {
                                    _this.openNewFile();
                                });
                            } else {
                                dialog.confirm({
                                    title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.SELECT_FILE"),
                                    body: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.DIALOG_CONFIRM.BODY"),
                                    accept: $translate.instant("DASHBOARD.ACCEPT"),
                                    cancel: $translate.instant("DASHBOARD.CANCEL"),
                                    size: "md",
                                })
                                .then(function () {
                                    $scope.fileContent = undefined;
                                    _this.fileContent = undefined;
                                    _this.formName = "";
                                    _this.importNotes = [];
                                    _this.integrationChoices = [];
                                    _this.openNewFile();
                                });
                            }
                        }
                    };
                
                    _this.openNewFile = function () {
                        // Create file input, open the file selection window, asign value to fileContent.
                        var input = document.createElement('input');
                        input.type = 'file';
                        input.accept = '.json'; // Only .json files
                        input.style.display = 'none';
                        document.body.appendChild(input);
                
                        input.addEventListener('change', function () {
                            var file = input.files[0];
                            var reader = new FileReader();
                            reader.onload = function (event) {
                                try {
                                    // Parse JSON content
                                    var fileContent = JSON.parse(event.target.result);
                                    $scope.$apply(function () {
                                        $scope.fileContent = fileContent;
                                    });
                                    _this.fileContent = fileContent; // Almacenar el contenido como objeto
                                    
                                    if (!fileContent?.form) {
                                        _this.clearFileInput(true);
                                        throw new Error("FILE_WITHOUT_FORM");
                                    } else {
                                        _this.formName = fileContent?.form?.name || '';
                                        if (_this.integrationsReady) {
                                            _this.buildIntegrationChoices();
                                        }
                                        _this.setImportNotes(fileContent);
                                        $scope.$apply(); // Angular update view
                                    }
                                    // console.log('$scope.fileContent', $scope.fileContent);
                                    // console.log('_this.fileContent', _this.fileContent);
                                } catch (error) {
                                    console.error('Error parsing JSON:', error);
                                    if (error.message === "FILE_WITHOUT_FORM") {
                                        toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.FILE_WITHOUT_FORM"));
                                    } else {
                                        toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.FILE_VALID"));
                                    }
                                }
                            };
                            reader.readAsText(file);
                            document.body.removeChild(input);
                        });
                    
                        input.click();
                    }
                    this.replaceIntegrationIds = function(form, integrationMapping) {
                        function walkNodesUpd(fields,integrationMapping){
                            fields.forEach(function(field) {
                                if (field.integration && integrationMapping[field.integration.id]) {
                                    field.integration.id = integrationMapping[field.integration.id];
                                }
                                if(field.nodes!=undefined && field.nodes.length>0)
                                    walkNodesUpd(field.nodes,integrationMapping);
                            });
                        }

                        
                        [form.pages, form.validate_pages].forEach(pages => {
                            pages?.forEach(page => {
                                if (Array.isArray(page.fields)) {
                                    walkNodesUpd(page.fields, integrationMapping);
                                }
                            });
                        });
                    };

                    this.processIntegrations = function() {
                        // console.log('entro a processIntegrations')
                        if (!_this.fileContent?.integrations || !_this.fileContent?.integrations.length) {
                            // console.log('no hay integraciones')
                            return Promise.resolve({}); // Returns a resolved promise with an empty object if there are no integrations
                        }
                    
                        // Collect all integration IDs in the form
                        const integrationIdsInForm = new Set();
                        
                        const collectIntegrationIds = (field) => {
                            if (field.integration && field.integration.id) {
                                integrationIdsInForm.add(field.integration.id);
                            }
                    
                            if (field.nodes && Array.isArray(field.nodes)) {
                                field.nodes.forEach(collectIntegrationIds);
                            }
                        };

                        [_this.fileContent.form.pages, _this.fileContent.form.validate_pages]
                            .forEach(pages => pages?.forEach(page => page.fields.forEach(collectIntegrationIds)));

                        const integrationIdsInFile = new Set(_this.fileContent.integrations.map(integration => integration.id));
                        
                        // Verify if all IDs in the form match the IDs in the integrations
                        for (let id of integrationIdsInForm) {
                            if (!integrationIdsInFile.has(id)) {
                                // If any ID doesn't match, throw an error
                                return Promise.reject(new Error("INTEGRATION_ID_MISMATCH:" + id));
                            }
                        }
                    
                        // Integration.find() fetches all available integrations from the backend
                        return Integration.find()
                        .$promise
                        .then(function (integrationsList) {
                            const byId = {};
                            (integrationsList || []).forEach(function (integration) {
                                byId[integration.id] = integration;
                            });

                            let integrationMapping = {};
                            const created = [];
                            const reused = [];

                            let integrationPromises = _this.integrationChoices.map(function (choice) {
                                return new Promise(function (resolve, reject) {
                                    if (choice.selectedId && choice.selectedId !== _this.CREATE_NEW) {
                                        const existing = byId[choice.selectedId];
                                        if (!existing) {
                                            reject(new Error("INTEGRATION_MISSING:" + (choice.name || choice.oldId)));
                                            return;
                                        }
                                        integrationMapping[choice.oldId] = existing.id;
                                        reused.push(existing.name || choice.name);
                                        resolve();
                                        return;
                                    }

                                    const source = (_this.fileContent.integrations || []).find(function (integration) {
                                        return integration.id === choice.oldId;
                                    });
                                    if (!source) {
                                        reject(new Error("INTEGRATION_ID_MISMATCH:" + choice.oldId));
                                        return;
                                    }

                                    let intToPost = JSON.parse(JSON.stringify(source));
                                    delete intToPost.id;
                                    delete intToPost.oldId;
                                    delete intToPost.tenantId;
                                    delete intToPost.clientId;
                                    delete intToPost.departmentId;
                                    sanitizeMongoKeys.prepareIntegration(intToPost);

                                    Integration.create({}, intToPost).$promise
                                        .then(function (intResp) {
                                            integrationMapping[choice.oldId] = intResp.id;
                                            created.push(intResp.name || choice.name);
                                            resolve();
                                        })
                                        .catch(function (error) {
                                            console.log(error);
                                            reject(new Error("Error Integration.create: " + error.message));
                                        });
                                });
                            });

                            return Promise.all(integrationPromises).then(function () {
                                _this.createdIntegrationNames = created;
                                _this.reusedIntegrationNames = reused;
                                return integrationMapping;
                            });
                        });
                    };
                    
                    this.processForm = function(integrationMapping) {
                        // console.log('this.processForm = function(integrationMapping) {', integrationMapping)
                        return new Promise(function(resolve, reject) {
                            let form = angular.copy(_this.fileContent.form);
                            let reportConfig = undefined;
                            form.name = _this.formName;

                            if (_this.fileContent?.reportConfig) {
                                reportConfig = angular.copy(_this.fileContent.reportConfig);
                            }

                            if (!form?.name?.trim()) {
                                return reject(new Error("NO_NAME"));
                            }

                            for (let i = 0; i < form.pages.length; i++) {
                                if (!form.pages[i].fields.length) {
                                    return reject(new Error("PAGE_WITHOUT_ELEMENTS:" + (i + 1)));
                                }
                            }

                            // Replace integration ID's only if there are elements in integrationMapping
                            if (Object.keys(integrationMapping).length > 0) {
                                _this.replaceIntegrationIds(form, integrationMapping);
                            }
                        
                            let _items = angular.copy(form.items || []);
                            form.items = null;
                        
                            if (form.type && form.workflow) {
                                form.metadata = form.metadata || [];
                                // _this.setMetadataFromWorkflow(form.type, form.workflow, form.metadata);
                            } else {
                                form.type = null;
                            }
                        
                            delete $state.params.selectedTab;
                        
                            delete form.id;
                            delete form.departmentId;
                            delete form.tenantId;

                            // Return modified form for the next step
                            resolve(form);
                        })
                    };

                    // Function to handle the logic after form creation.
                    function postForm(modifiedForm) {
                        return Department.forms.create({ id: $state.params.departmentId }, modifiedForm)
                            .$promise
                            .then(function (instance) {
                                if (_this.fileContent?.reportConfig) {
                                    let reportConfig = angular.copy(_this.fileContent.reportConfig);

                                    if (Array.isArray(reportConfig) && reportConfig.length > 0) {
                                        reportConfig = reportConfig[0];
                                    }

                                    delete reportConfig.id;
                                    delete reportConfig.formId;

                                    reportConfig.formId = instance.id;
                                    migrateReportDinamicEmail.applyLegacyConditions(reportConfig);

                                    return ReportConfig.create(reportConfig)
                                        .$promise
                                        .then(function (rpt) {
                                            reportConfig.id = rpt.id;
                                            toast.success($translate.instant("DASHBOARD.DASH_FORM.REPORT.LBL_CONFIG_OK"));

                                            return $state.go("dashboard.departments.department.forms", {}, { reload: true })
                                                .then(function () {
                                                    return $state.go("dashboard.departments.department.forms.form.builder", { formId: instance.id });
                                                });
                                        })
                                        .catch(function(error) {
                                            console.log(error);
                                            throw new Error("Error ReportConfig.create: " + error.message);
                                        });
                                } else {
                                    return $state.go("dashboard.departments.department.forms", {}, { reload: true })
                                        .then(function () {
                                            return $state.go("dashboard.departments.department.forms.form.builder", { formId: instance.id });
                                        });
                                }
                            })
                            .catch(function(error) {
                                console.log(error);
                                throw new Error("Error Department.forms.create: " + error.message);
                            });
                    }

                    this.close = function () {
                        if (_this.fileContent?.form || _this.formName == '') {
                            if ((_this.fileContent.integrations || []).length && !_this.integrationsReady) {
                                toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.INTEGRATIONS_LOADING"));
                                return;
                            }

                            const pendingChoice = (_this.integrationChoices || []).find(function (choice) {
                                return !choice.selectedId;
                            });
                            if (pendingChoice) {
                                toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.MISSING_INTEGRATION", {
                                    name: pendingChoice.name,
                                }));
                                return;
                            }

                            _this.loading = true;
                            // console.log('if (_this.fileContent?.form) {', _this.fileContent);
                            _this.processIntegrations()
                                .then(function (integrationMapping) {
                                    // console.log('_this.processIntegrations() then, integrationMapping:', integrationMapping)
                                    return _this.processForm(integrationMapping);
                                })
                                .then(function (modifiedForm) {
                                    // console.log('_this.processForm() then, modifiedForm:', modifiedForm)
                                    return postForm(modifiedForm);
                                })
                                .then(function () {
                                    _this.loading = false;
                                    toast.success($translate.instant("DASHBOARD.DASH_BUILDER.SAVE_OK_TOAST"));
                                    $uibModalInstance.close({});

                                    const summary = [];
                                    if (_this.createdIntegrationNames.length) {
                                        summary.push($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.SUMMARY_CREATED", {
                                            names: _this.createdIntegrationNames.join(", "),
                                        }));
                                    }
                                    if (_this.reusedIntegrationNames.length) {
                                        summary.push($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.SUMMARY_REUSED", {
                                            names: _this.reusedIntegrationNames.join(", "),
                                        }));
                                    }
                                    if (summary.length) {
                                        dialog.alert({
                                            title: $translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.SUMMARY_TITLE"),
                                            body: summary.join(" "),
                                            close: $translate.instant("DASHBOARD.CLOSE"),
                                            size: "md",
                                        });
                                    }
                                })
                                .catch(function (error) {
                                    _this.loading = false;
                                    console.error(error);

                                    const message = error && error.message ? error.message : "";
                                    if (message.indexOf("Error Integration.create:") === 0) {
                                        toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.INTEGRATION_CREATE_ERROR", {
                                            message: message.replace("Error Integration.create: ", ""),
                                        }));
                                    } else if (message.indexOf("INTEGRATION_MISSING:") === 0) {
                                        toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.MISSING_INTEGRATION", {
                                            name: message.split(":").slice(1).join(":"),
                                        }));
                                    } else if (message === "NO_NAME") {
                                        toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.NO_NAME"));
                                    } else if (message.indexOf("PAGE_WITHOUT_ELEMENTS:") === 0) {
                                        toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.PAGE_WITHOUT_ELEMENTS", {
                                            page: message.split(":")[1],
                                        }));
                                    } else if (message.indexOf("INTEGRATION_ID_MISMATCH:") === 0) {
                                        toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.INTEGRATION_ID_MISMATCH", {
                                            id: message.split(":").slice(1).join(":"),
                                        }));
                                    } else {
                                        toast.error($translate.instant("DASHBOARD.DASH_FORM.DIAG_IMPORT.IMPORT_ERROR"));
                                    }
                                });
                        } else {
                            if (!_this.fileContent) {
                                toast.success(
                                    $translate.instant(
                                        "DASHBOARD.DASH_FORM.DIAG_IMPORT.FILE_VALID"
                                    )
                                );
                            } else {
                                toast.success(
                                    $translate.instant(
                                        "DASHBOARD.DASH_FORM.DIAG_IMPORT.FILE_WITHOUT_FORM"
                                    )
                                );
                            }
                        }
                    };
                },
            ],
            resolve: {},
            controllerAs: "ctrl",
            size: "llg",
            windowClass: "dialog",
            bindToController: true,
        })
        .result.then(
            function (params) {
            }
        );
    };


    // Department Report Config
    this.openDeptReportConfig = function() {
        toast.loading($translate.instant("DASHBOARD.LOADING"));
        $uibModal
        .open({
            animation: true,
            templateUrl: "dashboard-forms/departmentReportConfig.html",
            controller: 'departmentReportConfigCtrl as ctrl',
            resolve: {
                departmentReportConfig: function () {
                    let src = _this.departmentReportConfig !== undefined && _this.departmentReportConfig !== null
                        ? _this.departmentReportConfig
                        : _this.department.reportConfig;
                    if (src) {
                        return JSON.parse(JSON.stringify(src));
                    }
                    return undefined;
                },
                department: function () {
                    return _this.department;
                }
            },
            controllerAs: "ctrl",
            size: "xlg",
            windowClass: "dialog",
            bindToController: true,
        })
        .result.then(
            function (params) {
                // console.log('params', params);

                if (params.save) {
                    _this.departmentReportConfig = params.departmentReportConfig;
                     console.log('_this.department', _this.department);
                    _this.department = params.department;
                    _this.department.reportConfig = params.departmentReportConfig;

                    Department.upsert(_this.department)
                    .$promise.then(function (department) {
                        toast.success($translate.instant("OK"));
                        // console.log('department', department);
                    })
                    .catch(function (error) {
                        // _this.loading = false;
                        console.log(error);
                    });
                }
            }
        );
    };
};
